'use strict';

angular
	.module('rmTemplate')
	.controller('TemplateOverviewCtrl', require('./template_overview_ctrl'))
	.controller('TemplateFormCtrl', require('./template_form_ctrl'))
	.controller('TemplateItemCtrl', require('./template_item_ctrl'));

